import { memo, useCallback, useState } from "react";

import { Button } from "~/components/button/Button";
import { DialogModal } from "~/components/dialogModal/DialogModal";
import { Menu } from "~/components/menu/Menu";
import { MenuItem } from "~/components/menu/MenuItem";
import { useLabels } from "~/hooks/useLabels";
import { useUserContext } from "~/hooks/useUserContext";
import { getFullUrl } from "~/utils/url";
import { HELP_CENTER_URL } from "~/constants";

export const SessionUserMenu = memo(function SessionUserMenu() {
  const { currentUser } = useUserContext();
  const { t } = useLabels();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleRequestClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const renderButton = useCallback(() => {
    return (
      <Button
        icon="user"
        iconVariant="solid"
        shape="circle"
        appearance="control"
        onClick={handleClick}
      />
    );
  }, [handleClick]);

  const renderModalContent = useCallback(() => {
    if (currentUser) {
      return (
        <Menu>
          <MenuItem
            href={getFullUrl("/account/", { includeBasePath: false })}
            icon="user"
            iconVariant="solid"
          >
            {t("session.user_menu.account")}
          </MenuItem>
          <MenuItem
            href={HELP_CENTER_URL}
            icon="circle-question"
            iconVariant="solid"
          >
            {t("session.user_menu.help_center")}
          </MenuItem>
          <MenuItem
            href="https://bibleproject.com/"
            iconVariant="brand"
            icon="bibleproject"
          >
            {t("session.user_menu.bibleproject_home")}
          </MenuItem>
          <MenuItem
            href={getFullUrl("/account/logout/", { includeBasePath: false })}
            icon="arrow-left-to-bracket"
            target="_self"
          >
            {t("session.user_menu.sign_out")}
          </MenuItem>
        </Menu>
      );
    }

    return (
      <Menu>
        <MenuItem
          href={HELP_CENTER_URL}
          icon="circle-question"
          iconVariant="solid"
        >
          {t("session.user_menu.help_center")}
        </MenuItem>
        <MenuItem
          href="https://bibleproject.com/"
          iconVariant="brand"
          icon="bibleproject"
        >
          {t("session.user_menu.bibleproject_home")}
        </MenuItem>
        <MenuItem
          href={getFullUrl(
            `/account/login/?redirect=${globalThis.location.href}`,
            { includeBasePath: false },
          )}
          target="_self"
          icon="arrow-right-from-bracket"
        >
          {t("session.user_menu.sign_in")}
        </MenuItem>
      </Menu>
    );
  }, [currentUser, t]);

  return (
    <>
      {renderButton()}

      <DialogModal
        isOpen={isModalOpen}
        size="sm"
        onRequestClose={handleRequestClose}
      >
        <DialogModal.Body>{renderModalContent()}</DialogModal.Body>
      </DialogModal>
    </>
  );
});
